/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type BUDGET_TYPE = "FIXED_PRICE" | "FIXED_PRICE_V2" | "NON_BILLABLE" | "RETAINER" | "TIME_AND_MATERIALS" | "%future added value";
export type BudgetPage_project = {
    readonly id: string;
    readonly financialDataAvailability: number | null;
    readonly manualProgressOnProjectEnabled: boolean | null;
    readonly manualProgressOnPhasesEnabled: boolean | null;
    readonly manualProgressOnTasksEnabled: boolean | null;
    readonly budgetType: BUDGET_TYPE | null;
    readonly " $fragmentRefs": FragmentRefs<"BudgetPageHeader_project" | "BudgetData_project" | "TimeBudgetData_project" | "Details_project" | "InvoiceDetails_project" | "TimeDetails_project" | "ExpenseDetails_project">;
    readonly " $refType": "BudgetPage_project";
};
export type BudgetPage_project$data = BudgetPage_project;
export type BudgetPage_project$key = {
    readonly " $data"?: BudgetPage_project$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"BudgetPage_project">;
};



const node: ReaderFragment = (function(){
var v0 = [
  {
    "kind": "Variable",
    "name": "currentMonth",
    "variableName": "currentMonth"
  },
  {
    "kind": "Variable",
    "name": "currentMonthLastDay",
    "variableName": "currentMonthLastDay"
  },
  {
    "kind": "Variable",
    "name": "currentYear",
    "variableName": "currentYear"
  }
];
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "projectId",
      "type": "String"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "currentYear",
      "type": "Int"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "currentMonth",
      "type": "Int"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "currentMonthLastDay",
      "type": "Int"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "BudgetPage_project",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "financialDataAvailability",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "manualProgressOnProjectEnabled",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "manualProgressOnPhasesEnabled",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "manualProgressOnTasksEnabled",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "budgetType",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "BudgetPageHeader_project"
    },
    {
      "args": (v0/*: any*/),
      "kind": "FragmentSpread",
      "name": "BudgetData_project"
    },
    {
      "args": (v0/*: any*/),
      "kind": "FragmentSpread",
      "name": "TimeBudgetData_project"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "Details_project"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "InvoiceDetails_project"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TimeDetails_project"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ExpenseDetails_project"
    }
  ],
  "type": "ProjectType"
};
})();
(node as any).hash = 'b01969ae1d4bb59f800464cbb9f89566';
export default node;
